import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'

export function passwordMatch(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.get('password')
    const confirmPassword = control.get('password_confirmation')
    return password?.value === confirmPassword?.value ? null : { notMatched: true }
  }
}

export function passwordValidationNumber(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const hasOneNumber = /.*\d.*/.test(control.value)

    return !hasOneNumber ? { atLeastOneNumber: true } : null
  }
}

export function passwordValidationLetters(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const hasLettersAndSymbols = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[\W_]).*$/.test(control.value)

    return !hasLettersAndSymbols ? { letterAndSymbol: true } : null
  }
}

export function passwordValidationSpecialCharacter(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const hasSpecialCharacter = /[\W_]/.test(control.value)

    return !hasSpecialCharacter ? { atLeastOneSpecialCharacter: true } : null
  }
}

export function validateUppercaseLetter(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const hasUppercase = /[A-Z]/.test(control.value)
    return !hasUppercase ? { uppercaseLetter: true } : null
  }
}

export function validateLowercaseLetter(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const hasLowercase = /[a-z]/.test(control.value)
    return !hasLowercase ? { lowercaseLetter: true } : null
  }
}
